var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9159 21.2068L31.56 23.5723C31.69 23.6886 31.755 23.7468 31.7445 23.7995C31.7412 23.8157 31.734 23.8313 31.7235 23.8448C31.6895 23.8888 31.5976 23.8888 31.4139 23.8888L27 23.8888L21.6124 23.8888C21.542 23.8888 21.5068 23.8888 21.4829 23.8714C21.4752 23.8658 21.4684 23.859 21.463 23.8512C21.4461 23.8271 21.447 23.7923 21.4488 23.7226L21.5856 18.5103C21.5876 18.4309 21.5887 18.3912 21.6103 18.363C21.6173 18.3539 21.6256 18.3459 21.635 18.3393C21.6641 18.3186 21.7042 18.3187 21.7844 18.3188L24.4581 18.3226L25.6052 18.3242L27.8992 18.3275L30.1932 18.3307L31.4679 18.3326C31.6343 18.3328 31.7175 18.3329 31.7433 18.3745C31.7513 18.3873 31.7559 18.4022 31.7567 18.4178C31.7592 18.4683 31.6937 18.5256 31.5627 18.6402L28.9319 20.9404C28.8665 20.9976 28.8338 21.0262 28.8258 21.0606C28.8233 21.0717 28.8226 21.083 28.8238 21.0939C28.8277 21.1279 28.8571 21.1542 28.9159 21.2068Z",
    stroke: "#CA1211",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4445 31.6669L21.4445 16.1113",
    stroke: "#CA1211",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2222 29.4444H24.8889C25.4412 29.4444 25.8889 29.8922 25.8889 30.4444V32.8159C25.8889 33.1469 25.7248 33.4593 25.4458 33.6374C22.5398 35.4931 20.6414 35.4168 17.4921 33.6316C17.1858 33.458 17 33.1294 17 32.7773V30.4444C17 29.8922 17.4477 29.4444 18 29.4444H18.6667",
    stroke: "#CA1211",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.4445,
    cy: 16.1111,
    r: 1.11111,
    fill: "#CA1211"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleAddress);
export default __webpack_public_path__ + "static/media/titleAddress.c4de0fd6e07a004c379dad4eb2bcf4f0.svg";
export { ForwardRef as ReactComponent };